import {
  SET_RELIC_VAULT_STATE,
  SET_RELIC_VAULT_HYDRATED,
  ADD_OWNED_RELIC,
  REMOVE_OWNED_RELIC,
  ADD_OWNED_COMPANION,
  SET_EQUIPPED_COMPANION,
  SET_STORE_SLOTS,
  ADJUST_RELIC_VAULT_BALANCE,
  RESET_RELIC_VAULT_BALANCE_ADJUSTMENT,
  RESET_RELIC_VAULT,
} from './actionTypes';
import { COMPANION_NONE_ID } from 'config/relicVault/companions';

// One ownership state shared by the store and the vault browser: a relic bought
// in the store shows as discovered in the vault immediately, and selling it in
// the vault makes it purchasable in the store again.
const initialState = {
  // True once we've tried to load persisted state (from the DB, later).
  hydrated: false,
  ownedRelicIds: [],
  // Companion ownership is keyed by guildId ("quik"), not companion id.
  ownedCompanionIds: [],
  // Badges the player has earned, by badge id ("EXP-001"). Badges are awarded
  // by the backend for hitting their requirement, never bought here.
  ownedBadgeIds: [],
  // guildId of the companion following the avatar, or "none".
  equippedCompanionId: COMPANION_NONE_ID,

  // The relic slots currently offered, plus the shuffle-bag they're drawn from.
  storeRelicIds: [],
  storeDeck: [],
  storeDeckPos: 0,
  lastRefreshDate: null,
  refreshesUsedToday: 0,

  // QuikCoins spent (negative) or refunded (positive) locally while the
  // backend doesn't debit yet. Displayed balance = real balance + this.
  balanceAdjustment: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_RELIC_VAULT_STATE:
      return { ...state, ...action.payload, hydrated: true };
    case SET_RELIC_VAULT_HYDRATED:
      return { ...state, hydrated: !!action.payload };
    case ADD_OWNED_RELIC:
      return state.ownedRelicIds.includes(action.payload)
        ? state
        : { ...state, ownedRelicIds: [...state.ownedRelicIds, action.payload] };
    case REMOVE_OWNED_RELIC:
      return {
        ...state,
        ownedRelicIds: state.ownedRelicIds.filter(id => id !== action.payload),
      };
    case ADD_OWNED_COMPANION:
      return state.ownedCompanionIds.includes(action.payload)
        ? state
        : {
            ...state,
            ownedCompanionIds: [...state.ownedCompanionIds, action.payload],
          };
    case SET_EQUIPPED_COMPANION:
      return { ...state, equippedCompanionId: action.payload };
    case SET_STORE_SLOTS:
      return { ...state, ...action.payload };
    case ADJUST_RELIC_VAULT_BALANCE:
      return {
        ...state,
        balanceAdjustment: state.balanceAdjustment + action.payload,
      };
    case RESET_RELIC_VAULT_BALANCE_ADJUSTMENT:
      return { ...state, balanceAdjustment: 0 };
    case RESET_RELIC_VAULT:
      return { ...initialState };
    default:
      return state;
  }
};

export default reducer;
